import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { NotificationsComponent }  from './notifications.component';
import { NWMControls } from 'app/components/Controls/NWMControls.module';

@NgModule({
    imports: [
        FormsModule,
        BrowserModule,
        RouterModule,
        NgbModule,
        NWMControls,
        NotificationsComponent
    ],
    providers: []
})
export class NotificationsModule{}